// React and related imports
import React from 'react';

// Icons
import { HiCheck } from 'react-icons/hi';

interface SelectIndicatorProps {
  isSelected: boolean;
}

export const SelectIndicator: React.FC<SelectIndicatorProps> = ({
  isSelected,
}) => (
  <div
    className={`flex h-6 w-6 items-center justify-center rounded-full border-2 transition-colors duration-200 ${
      isSelected
        ? 'border-primary-500 bg-primary-500'
        : 'border-white bg-black/30 group-hover:bg-black/50'
    }`}
  >
    {isSelected && <HiCheck className="h-3 w-3 text-white" />}
  </div>
);
